var _circle, _rect, _path, _rect2, _path2, _rect3, _path3, _ellipse, _ellipse2, _g, _rect4, _circle2, _rect5, _path4, _rect6, _path5, _rect7, _path6, _ellipse3, _ellipse4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 15,
    r: 3,
    stroke: "#50595F",
    strokeWidth: 1.1,
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 8,
    height: 10,
    rx: 2,
    stroke: "#50595F",
    strokeWidth: 1.1,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25h4M20 27h4",
    stroke: "#50595F",
    strokeWidth: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 12,
    height: 18,
    rx: 1,
    stroke: "#50595F",
    strokeWidth: 1.1,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20c1.5 2 2.5 2 3 0 1.5 2 2.5 2 3 0 1.5 2 2.5 2 3 0",
    stroke: "#50595F",
    strokeWidth: 0.7,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 8,
    height: 5,
    rx: 0.5,
    stroke: "#50595F",
    strokeWidth: 0.7,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27l1 2h4l1-2",
    stroke: "#50595F",
    strokeWidth: 0.7,
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 29,
    rx: 0.8,
    ry: 0.8,
    stroke: "#50595F",
    strokeWidth: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 29,
    rx: 0.8,
    ry: 0.8,
    stroke: "#50595F",
    strokeWidth: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_marketplace)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 59,
    r: 3,
    stroke: "url(#paint0_linear_marketplace)",
    strokeWidth: 1.1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 64,
    width: 8,
    height: 10,
    rx: 2,
    stroke: "url(#paint1_linear_marketplace)",
    strokeWidth: 1.1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 69h4M20 71h4",
    stroke: "url(#paint1_linear_marketplace)",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 56,
    width: 12,
    height: 18,
    rx: 1,
    stroke: "url(#paint2_linear_marketplace)",
    strokeWidth: 1.1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 64c1.5 2 2.5 2 3 0 1.5 2 2.5 2 3 0 1.5 2 2.5 2 3 0",
    stroke: "url(#paint2_linear_marketplace)",
    strokeWidth: 0.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 66,
    width: 8,
    height: 5,
    rx: 0.5,
    stroke: "url(#paint2_linear_marketplace)",
    strokeWidth: 0.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 71l1 2h4l1-2",
    stroke: "url(#paint2_linear_marketplace)",
    strokeWidth: 0.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 73,
    rx: 0.8,
    ry: 0.8,
    stroke: "url(#paint2_linear_marketplace)",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 73,
    rx: 0.8,
    ry: 0.8,
    stroke: "url(#paint2_linear_marketplace)",
    strokeWidth: 0.7
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 103,
    r: 3,
    stroke: "white",
    strokeWidth: 1.1,
    fill: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 108,
    width: 8,
    height: 10,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.1,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 113h4M20 115h4",
    stroke: "white",
    strokeWidth: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 100,
    width: 12,
    height: 18,
    rx: 1,
    stroke: "white",
    strokeWidth: 1.1,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 108c1.5 2 2.5 2 3 0 1.5 2 2.5 2 3 0 1.5 2 2.5 2 3 0",
    stroke: "white",
    strokeWidth: 0.7,
    fill: "none"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 110,
    width: 8,
    height: 5,
    rx: 0.5,
    stroke: "white",
    strokeWidth: 0.7,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 115l1 2h4l1-2",
    stroke: "white",
    strokeWidth: 0.7,
    fill: "none"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 117,
    rx: 0.8,
    ry: 0.8,
    stroke: "white",
    strokeWidth: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 117,
    rx: 0.8,
    ry: 0.8,
    stroke: "white",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_marketplace",
    x: 17,
    y: 50.4,
    width: 33,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_marketplace"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_marketplace",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_marketplace",
    x1: 22,
    y1: 56,
    x2: 22,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_marketplace",
    x1: 22,
    y1: 64,
    x2: 22,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_marketplace",
    x1: 36,
    y1: 56,
    x2: 36,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMarketplace);
export default __webpack_public_path__ + "static/media/agent_marketplace.104487cdd8ff3450eef723444f5066a6.svg";
export { ForwardRef as ReactComponent };